import { html, css, LitElement } from '~/lib/bn-lit-element';
import { entityStore, userManager } from '~/utility/BinSentry-ui-utility';

import './a2hs/a2hs-toast';
import './binsentry-main';
import './binsentry-splash';
import './common/bn-progressbar';
import './issue-viewer/issue-viewer';
import './login/login-page';
import './login/login-redirect-page';
import './login/logout-page';
import './login/logout-redirect-page';
import './public/nuke-storage';
import './public/qr-test';
import './confirm/user-confirmation-page';
import { mainStyles } from './styles/shared-styles';
import { StoreMixin } from './utility/store-mixin';

class BinSentryApp extends StoreMixin(LitElement) {
  constructor() {
    super();
    this.publicRoutes = ['qr-test', 'nuke', 'clear', 'issue-viewer', 'login-redirect', 'logout', 'login', 'logged-out', 'confirm'];
    this.progress = 100;
  }

  createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      view: { type: String },
      // HREFs
      currentOrgHref: { type: String },
      primaryOrgHref: { type: String },
      // Progress
      inflight: { type: Number },
      progress: { type: Number },
      authConfig: { type: Object },
      href: { type: String },
    };
  }

  static get styles() {
    return [mainStyles, css`
      .page {
        margin: 0;
        padding: 0;
        height: 100%;
      }
      binsentry-main {
        height: 100%;
      }
      @media print {
        bn-progressbar {
          display: none;
        }
      }
    `];
  }

  render() {
    const { progress } = this;
    return html`
      <style>${BinSentryApp.styles.join(' ')}</style>
      <div class="page">
        <bn-progressbar .progress="${progress}"></bn-progressbar>
        ${this.renderPage()}
      </div>
      <a2hs-toast></a2hs-toast>
    `;
  }

  renderPage() {
    switch (this.view) {
    case 'qr-test':
      return html`<qr-test></qr-test>`;
    case 'issue-viewer':
      return html`<issue-viewer></issue-viewer>`;
    case 'nuke':
    case 'clear':
      return html`<nuke-storage></nuke-storage>`;
    case 'login':
      return html`<login-page></login-page>`;
    case 'login-redirect':
      return html`<login-redirect-page auth-domain="${this.authConfig?.domain}"></login-redirect-page>`;
    case 'logged-out':
      return html`<logout-redirect-page></logout-redirect-page>`;
    case 'logout':
      return html`<logout-page></logout-page>`;
    case 'confirm':
      return html`<user-confirmation-page></user-confirmation-page>`;
    case 'main':
      return html`<binsentry-main .href="${this.href}"></binsentry-main>`;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this._handleInflightChange = this._handleInflightChange.bind(this);
    entityStore.addListener('inflight', this._handleInflightChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    entityStore.removeListener('inflight', this._handleInflightChange);
  }

  _handleInflightChange({ count }) {
    if (count === 0) {
      this.inflight = 0;
      this.progress = 100;
    } else {
      this.inflight = Math.max(count, this.inflight);
      this.progress = Math.round((this.inflight - count) / this.inflight * 100);
    }
  }

  _setView(view) {
    if (this.publicRoutes.includes(view)) {
      this.view = view;
      return;
    }

    // since it's a non-public view, we need a user, or else we redirect to login
    userManager.authenticatedUser().then(user => {
      if (user) {
        this.view = 'main';
      }
    });
  }

  async _stateChanged({ path, query }) {
    if (this.path !== path) {
      this.path = path;
      this.query = query;
      const parts = (path || '').toLowerCase().slice(1).split('/');
      this._setView(parts[0]);
    }
  }
}

window.customElements.define('binsentry-app', BinSentryApp);
